import { AwardCategory } from "@enums/awardCategory";
import { GalleryType } from "@enums/galleryType";
import { ISelectOption } from "@interfaces/Shared/selectOption";

export const getInitialSelectedOption = (
  options: ISelectOption[],
  valueOfOptionToFind: AwardCategory | GalleryType | string
) => options.find((option) => option.value === valueOfOptionToFind);
